module.exports = __webpack_public_path__ + "static/media/google-play-badge.90751241.png";